const PROFILE_QUERY_KEYS = "profile";

export const profileQueryKeys = {
  all: [PROFILE_QUERY_KEYS] as const,
  current: () => [PROFILE_QUERY_KEYS, "current"] as const,
  migration: () => [PROFILE_QUERY_KEYS, "migration"] as const,
};
